<template>
    <apexchart :width="width" :options="options" :series="options.series"></apexchart>
</template>

<script>

export default{
  name: 'PieChart',
  props: {
    legends: Array,
    data: Array,
    title: String,
    width: String,
    tooltip: Function,
    legendsPosition: String
  },
  data() {
    const colors = [];

    if (this.legends.length > 0) {
      this.legends.map( (legend) => {
        colors.push(
          '#'+parseInt((Math.random() * 0xFFFFFF)).toString(16).padStart(6, '0')
        );
      })
    }

    return {
      options: {
        series: this.data,
        chart: {
          width: 380,
          type: 'pie'
        },
        legend: {
          position: this.legendsPosition
        },
        labels: this.legends,
        theme: {
          monochrome: {
            enabled: true,
            color: '#AF104C'
          }
        },
        // colors,
        title: {
          text: this.title,
          align: 'center'
        },
        tooltip: {
          y: {
            formatter: this.tooltip
          }
        }
      }
    };
  }
}
</script>
